(function () {
  var root = document.querySelector('.lgk-devis-pc-form');
  if (!root) return;

  var form = root.querySelector('form.lgk-devis-pc-form__form');
  var openCombobox = null;

  function getValidationBanner() {
    if (!form) return null;
    var banner = form.querySelector('.lgk-devis-pc-form__validation-banner');
    if (banner) return banner;
    banner = document.createElement('div');
    banner.className = 'lgk-devis-pc-form__validation-banner';
    banner.setAttribute('role', 'alert');
    banner.hidden = true;
    form.insertBefore(banner, form.firstChild);
    return banner;
  }

  function clearValidation() {
    root.querySelectorAll('.is-invalid').forEach(function (el) {
      el.classList.remove('is-invalid');
    });
    var banner = getValidationBanner();
    if (banner) banner.hidden = true;
  }

  function fieldContainer(field) {
    return (
      field.closest('.lgk-devis-combobox') ||
      field.closest('.form-control') ||
      field.closest('.lgk-devis-pc-form__field') ||
      field.closest('.lgk-devis-pc-form__consent') ||
      field
    );
  }

  function markInvalid(field) {
    var container = fieldContainer(field);
    container.classList.add('is-invalid');
    var focusTarget =
      container.querySelector('.lgk-devis-combobox__trigger') ||
      container.querySelector('.input, .textarea, select') ||
      field;
    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus({ preventScroll: true });
    }
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return container;
  }

  function showValidationMessage(count) {
    var banner = getValidationBanner();
    if (!banner) return;
    banner.textContent =
      count > 1
        ? 'Il manque ' + count + ' champs obligatoires. Complétez les champs surlignés en rouge puis renvoyez le formulaire.'
        : 'Un champ obligatoire est manquant. Complétez le champ surligné en rouge puis renvoyez le formulaire.';
    banner.hidden = false;
  }

  function bindValidation() {
    if (!form || form.dataset.lgkValidationBound) return;
    form.dataset.lgkValidationBound = '1';

    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      var clear = function () {
        fieldContainer(field).classList.remove('is-invalid');
      };
      field.addEventListener('input', clear);
      field.addEventListener('change', clear);
    });

    form.addEventListener(
      'invalid',
      function (e) {
        e.preventDefault();
        showValidationMessage(form.querySelectorAll(':invalid').length || 1);
        markInvalid(e.target);
      },
      true
    );

    form.addEventListener('submit', function (e) {
      clearValidation();
      if (form.checkValidity()) return;
      e.preventDefault();
      var invalidFields = form.querySelectorAll(':invalid');
      showValidationMessage(invalidFields.length);
      if (invalidFields.length) markInvalid(invalidFields[0]);
    });
  }

  function closeAll(except) {
    root.querySelectorAll('.lgk-devis-combobox.is-open').forEach(function (fc) {
      if (fc !== except) {
        fc.classList.remove('is-open', 'is-open-up');
        var list = fc.querySelector('.lgk-devis-combobox__list');
        var trigger = fc.querySelector('.lgk-devis-combobox__trigger');
        if (list) {
          list.hidden = true;
          list.style.maxHeight = '';
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
    if (!except) openCombobox = null;
  }

  function collisionSpaceBelow(trigger, fc) {
    var triggerRect = trigger.getBoundingClientRect();
    var limit = window.innerHeight - triggerRect.bottom - 12;
    var candidates = root.querySelectorAll(
      '.lgk-devis-pc-form__field, .lgk-devis-pc-form__group, .lgk-devis-pc-form__actions, .lgk-devis-pc-form__consent'
    );

    candidates.forEach(function (el) {
      if (el === fc || el.contains(fc) || fc.contains(el)) return;
      var rect = el.getBoundingClientRect();
      if (rect.top <= triggerRect.bottom + 4) return;
      if (rect.left >= triggerRect.right || rect.right <= triggerRect.left) return;
      var gap = rect.top - triggerRect.bottom - 8;
      if (gap >= 0 && gap < limit) limit = gap;
    });

    return Math.max(0, limit);
  }

  function updateListPlacement(fc, list, trigger) {
    var triggerRect = trigger.getBoundingClientRect();
    var spaceBelow = collisionSpaceBelow(trigger, fc);
    var spaceAbove = triggerRect.top - 12;
    var naturalHeight = list.scrollHeight;
    var maxH = Math.min(280, window.innerHeight * 0.45);
    var needsUp = naturalHeight > spaceBelow && spaceAbove > spaceBelow;
    var openUp = needsUp || (spaceBelow < 160 && spaceAbove > spaceBelow);
    var available = openUp ? spaceAbove : spaceBelow;

    fc.classList.toggle('is-open-up', openUp);
    list.style.maxHeight = Math.max(96, Math.min(maxH, available)) + 'px';
  }

  if (!window.__lgkDevisCombobox) {
    window.__lgkDevisCombobox = true;

    root.querySelectorAll('.form-control').forEach(function (fc) {
      var select = fc.querySelector('select.select');
      if (!select || select.dataset.lgkCombobox) return;
      select.dataset.lgkCombobox = '1';
      fc.classList.add('lgk-devis-combobox');

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'lgk-devis-combobox__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      var listId = select.id ? select.id + '-listbox' : 'lgk-combobox-list-' + Math.random().toString(36).slice(2);
      var list = document.createElement('ul');
      list.id = listId;
      list.className = 'lgk-devis-combobox__list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      trigger.setAttribute('aria-controls', listId);

      function labelForSelect() {
        var opt = select.options[select.selectedIndex];
        if (!opt || (!opt.value && opt.disabled)) {
          var fl = fc.querySelector('.floating-label');
          return fl ? fl.textContent.trim() : 'Choisir…';
        }
        return opt.textContent.trim();
      }

      function syncTrigger() {
        trigger.textContent = labelForSelect();
        list.querySelectorAll('[role="option"]').forEach(function (item) {
          item.setAttribute('aria-selected', item.dataset.value === select.value ? 'true' : 'false');
        });
        if (select.value) {
          select.classList.remove('lgk-devis-combobox__native--empty');
          fc.classList.add('lgk-devis-combobox--filled');
          fc.classList.remove('is-invalid');
        } else {
          select.classList.add('lgk-devis-combobox__native--empty');
          fc.classList.remove('lgk-devis-combobox--filled');
        }
      }

      Array.from(select.options).forEach(function (opt) {
        if (opt.disabled && !opt.value) return;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.value = opt.value;
        li.textContent = opt.textContent.trim();
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
        li.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncTrigger();
          closeAll();
        });
        list.appendChild(li);
      });

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (fc.classList.contains('is-open')) {
          closeAll();
          return;
        }
        closeAll(fc);
        list.hidden = false;
        fc.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        updateListPlacement(fc, list, trigger);
        openCombobox = { fc: fc, list: list, trigger: trigger };
      });

      list.addEventListener('wheel', function (e) {
        e.stopPropagation();
      });

      select.addEventListener('change', syncTrigger);
      select.classList.add('lgk-devis-combobox__native');
      fc.insertBefore(trigger, select);
      fc.appendChild(list);
      syncTrigger();
    });

    document.addEventListener('click', function () {
      closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    window.addEventListener(
      'scroll',
      function (e) {
        if (!openCombobox) return;
        if (e.target && e.target.closest && e.target.closest('.lgk-devis-combobox__list')) return;
        closeAll();
      },
      true
    );

    window.addEventListener('resize', function () {
      if (!openCombobox) return;
      updateListPlacement(openCombobox.fc, openCombobox.list, openCombobox.trigger);
    });
  }

  bindValidation();
})();
